import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconList$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconList extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e1c55dea885a1c73870b2950c81ea50c5daff515', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f7fbaee6b1c61d76f241711c9c0c79c19e37cf14', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9ab2721dbb64804667c7489e17d7d4ef4942752f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.26 7a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m1.25 4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m1.99-6a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM7 5.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 7 6zm.5 10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-list", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-list"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconList$1);
            }
            break;
    } });
}

const CosmosIconList = CosmosIconList$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconList, defineCustomElement };
